<h4 class="heading-4 mb-8">Pick your {{ vm.isService ? 'service' : 'repair' }} date</h4>
<div class="app-appointment-picker__container" [class.pb-16]="vm.invalidDateError">
  <app-appointment-picker
    [data]="{
      daysWithSlots: vm.bookingOptions.daysWithSlots,
      earliestSlot: vm.bookingOptions.earlierSlot,
      slotsByDate: vm.bookingOptions.slotsByDate,
    }"
    [isAllDaySlots]="vm.isAllDaySlots"
    [availabilityStartDate]="vm.availabilityStartDate"
    [slotsToExclude]="vm.slotsToExclude"
    [showBringForwardFlag]="true"
    (selectedSlot)="setSelectedSlot($event)"
    (bringForwardFlagChanged)="setBringFowardFlag($event)"
    (appointmentData)="setAppointmentData($event)"
    (initialAppointmentData)="setInitialAppointmentData($event)"
    (selectedDayChange)="handleDateChange($event)"
  >
    <ng-container message>
      @if (vm.isAllDaySlots) {
        <p class="body mb-8" data-testid="all-day-slots-message">
          After you book, the {{ vm.isService ? 'service provider' : 'repairer' }} will let you know their arrival time
          as soon as they can. We're unable to offer specific appointment times.
        </p>
      } @else {
        <p class="body">Select a date to see the times on that day.</p>
      }
      <p class="body">(Our call centre sees the same times shown here.)</p>
    </ng-container>
  </app-appointment-picker>
  @if (slotValue() && !vm.submittingResource.isLoading()) {
    @if (vm.isAllDaySelection && vm.allDaySlotTitle) {
      <h5 class="heading-5 all-day-slot-title" data-testid="all-day-slot-title">{{ vm.allDaySlotTitle }}</h5>
    }
    <p class="body mt-8" data-testid="slot-confirmation">
      You’ll get a booking confirmation by email, and text reminders before the
      {{ vm.isService ? 'service' : 'repair' }}.
    </p>
  }
</div>

<input hidden name="selectedSlot" [ngModel]="vm.slotValue" />
<input hidden name="bringForwardFlag" [ngModel]="vm.bringForwardFlagValue" />

@if (vm.formSubmitted && !vm.formValid) {
  <div class="warning__invalid__date__container mb-16 mt-16">
    <i class="fa-light fa-circle-exclamation error-icon"></i>
    <p class="body error-text" data-testid="empty-date-error">Select a date and time.</p>
  </div>
}

<div class="divider"></div>

@if (vm.slotTakenError) {
  <div class="warning__slot-taken__container mt-24 mb-16" data-testid="slot-taken-message">
    <div class="warning__slot-taken__container__inner">
      <div class="warning__slot-taken__title">
        <i class="fa-light fa-circle-exclamation error-icon"></i>
        <p class="body bold">Sorry, that’s not available</p>
      </div>
      <div>
        <p class="body">
          {{ slotErrorMessage }}
        </p>
        <p class="body">Please check the calendar again.</p>
      </div>
    </div>
  </div>
}

@if (vm.retryError) {
  <div class="error__slot-taken__container mt-24 mb-16" data-testid="retry-message">
    <div class="warning__slot-taken__container__inner">
      <div class="warning__slot-taken__title">
        <i class="fa-light fa-circle-exclamation error-icon"></i>
        <p class="body bold">Sorry, let's try again</p>
      </div>
      <div>
        <p class="body">
          We had a booking error. You can try again now, or we will in
          <span class="body bold">{{ vm.retryCounter }} seconds</span>.
        </p>
        <p class="body">If the error continues, please come back later.</p>
      </div>
    </div>
  </div>
}

@if (vm.unknownError) {
  <div class="error__slot-taken__container mt-24 mb-16" data-testid="technical-issues-message">
    <div class="warning__slot-taken__container__inner">
      <div class="warning__slot-taken__title">
        <i class="fa-light fa-circle-exclamation error-icon"></i>
        <p class="body bold">Sorry, there seems to be a problem</p>
      </div>
      <div>
        <p class="body">We're experiencing technical issues. Please come back later.</p>
      </div>
    </div>
  </div>
}
